import React from 'react'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'
import AlertContainer from 'react-alert'
import { parse as parseQuery } from 'query-string'

class SamlLogin extends React.PureComponent {
  alertOptions = {
    offset: 14,
    position: 'top right',
    theme: 'dark',
    time: 5000,
    transition: 'scale'
  }

  constructor (props, context) {
    super(props, context)

    this.state = {
      redirectToReferrer: false
    }
  }

  componentDidMount = () => {
    const query = parseQuery(this.props.location.search)
    const { token, user } = query
    if (!token || !user) {
      this.msg.show('Missing JWT token or user data', {
        time: 4000,
        type: 'error'
      })
    } else {
      this.props.onLogin(JSON.parse(user), token)
      this.setState({ redirectToReferrer: true })
    }
  }

  render () {
    if (this.state.redirectToReferrer) {
      return <Redirect to='/' />
    }

    return <div>
      <AlertContainer ref={a => (this.msg = a)} {...this.alertOptions} />
    </div>
  }
}

SamlLogin.propTypes = {
  onLogin: PropTypes.func,
  location: PropTypes.object
}

export default SamlLogin



// WEBPACK FOOTER //
// ./src/pages/SamlLogin/SamlLogin.js